import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\r\n",{ moduleName: "dac-error-budget/templates/application.hbs" })